//package import 
import React, { useEffect, useState,useRef} from "react";
import { useRouteMatch, useHistory } from "react-router-dom";
import { storeDetailedView, getStoreAmenities,getStoreDetails } from "../../services/apiServices/GetServices";
import { holidaysData } from "../../utils/TextInputUtils";

//component import 
import Loader from "../loadingScreens/Loader";

const StoreDetails = (props) => {
    const history = useHistory();
    const storeId = props?.location?.state?.info?.id
    const [arrayData, setArrayData] = useState([])
    const [storeAmenitiesData, setStoreAmenitiesData] = useState([])
    const uniqueName = props?.location?.state?.info?.unique_name
    const [isLoader,setIsLoader]=useState(false)
    // const googleMapKey = process.env.React_APP_Google_Api_Key


    useEffect(() => {
        callStoreDetails()
        getStoreAmenitiesApi()
    }, []);

    const callStoreDetails = async () => {
        setIsLoader(true)
        try{
            const res = await getStoreDetails(`storeDetails/${uniqueName}`);
            if (res.success) {
                setArrayData(res?.data[0])
            } else {
               // showToast("res", res?.message)
                console.log("res", res?.message)
            }
        }catch(error){
            console.log("error",error)
        }
       
    }

    //function to call Store Amenities
    const getStoreAmenitiesApi = async () => {
        try{
            const res = await getStoreAmenities("store_amenities")
            if (res?.success) {
                setStoreAmenitiesData(res?.data)
            } else {
                console.log("res", res?.message)
            }
        }catch(error){
            console.log("error",error)
        }
    }

    const handleBack = () => {
        history.push({
            pathname :"/admin/storeManagement",
            state :{
            isPublished : arrayData?.is_published
            }
        })
    }

    //function call to nativigate store edit 
    const handleStoreEdit = () => {
        history.push(
            {
                pathname: '/admin/storeManagement/addStoreForm',
                state: {
                    storeDetails: arrayData,
                    isPublished : arrayData?.is_published
                }
            })
    }

    const arrayAmenities = arrayData?.amenities != undefined ? arrayData?.amenities.split(",") : ""
    const holidaysArray = arrayData?.holidays != undefined ? arrayData?.holidays.split(",") : ""
    const holidayArrayData = holidaysData.filter(item => holidaysArray.includes(item.day))
    const filteredData = storeAmenitiesData.filter(item => arrayAmenities.includes(item.id.toString()));
    const displayImgArray = arrayData !== undefined ? arrayData.image_url !== undefined ? arrayData.image_url.split(",") : [] : ""
   
    //function call to format the time
    const handleTimeFormat = (dateValue) => {
        let date = new Date(dateValue);
        let hours = date.getHours() < 10 ? `0${date.getHours()}` : `${date.getHours()}`
        let minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : `${date.getMinutes()}` 
        const amPm = hours >= 12 ? 'PM' : 'AM';
        let dateMDY = `${hours}:${minutes}: ${amPm}`
         return dateMDY
      }

    //function call to format date
      const  formatDate = (dateValue) => {
        let date = new Date(dateValue)
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${day}-${month}-${year} `;
    }

    return (
        <div class="col-md-12">
            {isLoader ? <Loader/> : null}
            <div class="d-flex flex-row justify-content-between align-items-center  border-bottom p-2">
                <h1 class="fs-4 Montserrat fw-semi-bold">
                    Store Details
                </h1>
            </div>
            <div class="d-flex flex-column my-2">
                <div class="d-flex mx-4  my-1 w-75">
                    <h6 class="w-25 roboto status-pending fw-bold">Store Category</h6>
                    <h6 class="w-75 roboto">{arrayData?.service_name === "" ? "-" : arrayData?.service_name}</h6>
                </div>
                <div class="d-flex mx-4  my-1 w-75">
                    <h6 class="w-25 roboto status-pending fw-bold">State</h6>
                    <h6 class="w-75 roboto ">{arrayData?.state_name === "" ? "-" : arrayData?.state_name}</h6>
                </div>
                <div class="d-flex mx-4  my-1 w-75">
                    <h6 class="w-25 roboto status-pending fw-bold">City</h6>
                    <h6 class="w-75 roboto ">{arrayData?.city_name === "" ? "-" : arrayData?.city_name}</h6>
                </div>
                <div class="d-flex mx-4  my-1 w-75">
                    <h6 class="w-25 roboto status-pending fw-bold">Store Name</h6>
                    <h6 class="w-75 roboto ">{arrayData?.name === "" ? "-" : arrayData?.name}</h6>
                </div>
                <div class="d-flex mx-4  my-1 w-75">
                    <h6 class="w-25 roboto status-pending fw-bold">Open Time</h6>
                    <h6 class="w-75 roboto ">{arrayData?.open_time === "" ? "-" : handleTimeFormat(arrayData?.open_time)}</h6>
                </div>
                <div class="d-flex mx-4  my-1 w-75">
                    <h6 class="w-25 roboto status-pending fw-bold">Close Time</h6>
                    <h6 class="w-75 roboto ">{arrayData?.close_time === "" || arrayData?.close_time === "null" ? "-" : handleTimeFormat(arrayData?.close_time)}</h6>
                </div>
                <div class="d-flex mx-4  my-1 w-75">
                    <h6 class="w-25 roboto status-pending fw-bold">Launch Date</h6>
                    <h6 class="w-75 roboto ">{arrayData?.launch_date === "" || arrayData?.launch_date === "null" ? "-" : formatDate(arrayData?.launch_date)}</h6>
                </div>
                <div class="d-flex mx-4  my-1 w-75">
                    <h6 class="w-25 roboto status-pending fw-bold">About Store</h6>
                    <h6 class="w-75 roboto text-break ">{arrayData?.description === "" ? "-" : arrayData?.description
                    }</h6>
                </div>
                <div class="d-flex mx-4  align-items-center my-1 w-75">
                    <h6 class="w-25 roboto status-pending fw-bold">Holidays</h6>
                    <div class="d-flex w-75 ">
                        {arrayData?.holidays !== "" ?
                            holidayArrayData.map((data, index) => {
                                return (
                                    <div class="d-flex" key={data?.id}>
                                        <div class="d-flex flex-row " >
                                            <h6 class=" my-1 me-1">{data?.day} {index === holidayArrayData.length - 1 ? "" : ","} </h6>
                                        </div>
                                    </div>
                                )
                            })
                            :
                            "-"
                        }
                    </div>
                </div>
                <div class="d-flex mx-4 my-1 w-75">
                    <h6 class="w-25 roboto status-pending fw-bold">Address</h6>
                    <div class="d-flex flex-row w-75 text-start  ">
                        <div class="w-75 ">
                            <h6 class=" d-flex w-75 roboto  ">{arrayData?.address === "" ? "-" : arrayData?.address
                            }</h6>
                            <h6 class=" d-flex  roboto"><span class="paraColor fw-bold me-1">Phone number:</span>   {arrayData?.phone_number === "" ? "-" : arrayData?.phone_number}</h6>
                            <h6 class=" d-flex  roboto text-center"><span class="paraColor fw-bold me-1">Email:</span>   {arrayData?.email === "" ? "-" : arrayData?.email}</h6>
                        </div>
                    </div>
                </div>
                {/* <div class="d-flex mx-4  my-1 w-75">
                    <h6 class="w-25 roboto status-pending fw-bold">Google Reviews</h6>
                    <h6 class="w-75 roboto ">{arrayData?.review_url !== "" ? arrayData?.review_url : "-"}</h6>
                </div> */}
                <div class="d-flex mx-4  my-1 align-items-center w-75">
                    <h6 class="w-25 roboto status-pending fw-bold">Store Amenities</h6>
                    <div class="d-flex w-75 my-3  justify-content-start">
                        {
                            arrayData?.amenities !== "" ?
                            <>
                            {
                                filteredData.map((data,index) => {
                                    const iconstring = data?.icon
                                    return (
                                        <div class="d-flex w-25 text-start" key={index}>
                                            <div class="d-flex flex-column w-100" >
                                                <div class="my-2 text-center">
                                                    <img src={data?.icon_url} alt="aminities_icon"/>
                                                </div>
                                                <h6 class=" w-100 my-1 me-2 text-center">{data?.name}</h6>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                            </>
                            :
                            "-"
                        }
                    </div>
                </div>
                <div class="d-flex mx-4  my-2 w-75">
                    <h6 class="w-25 roboto status-pending fw-bold">Banner Image</h6>
                    <img src={arrayData?.banner_url} alt="thumbnail_url"  class="storeDisplayImages" />
                </div>
                <div class="d-flex mx-4  my-2 w-75">
                    <h6 class="w-25 roboto status-pending fw-bold">Thumbnail Image</h6>
                    <img src={arrayData?.thumbnail_url} alt="thumbnail_url"  class="storeDisplayImages" />
                </div>
                <div class="d-flex mx-4  my-1 w-75">
                    <h6 class="w-25 roboto status-pending fw-bold">Display Image</h6>
                    <div class="w-75  flex-wrap">
                        <div>
                        {arrayData !== undefined ?
                            displayImgArray.map((data,index) => {
                                return (
                                    <img src={data} alt="Display Image" class="storeDisplayImages" key={index}/>
                                )
                            }) :
                            "-"
                        }
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex w-75 justify-content-center align-items-center my-4">
                <div class="my-2 align-self-center mx-2" onClick={() => handleBack()}>
                    <button variant="contained" class="primaryButton px-4">
                        Back
                    </button>
                </div>
                <div class="my-2 align-self-center mx-2">
                    <button variant="contained" class="primaryButton px-4" onClick={() => handleStoreEdit()}>
                        Edit
                    </button>
                </div>
            </div>
        </div>
    )
}

export default StoreDetails